export default "__VITE_ASSET__8a449bcb__"